<script>
import bem from '@/utils/bem';

const b = bem('enhance-wizard-module');

export default {
  props: {
    moduleData: {
      type: Object,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isPopup: {
      type: Boolean,
      default: false,
    },
    companyColors: {
      type: Object,
      default: () => ({
        color1: '',
        color2: '',
        color3: '',
      }),
    },
  },
  emits: ['update'],
  computed: {
    cardsBackgroundColor() {
      if (!this.isEditMode && this.companyColors.color1) {
        return this.companyColors.color1;
      }
      return null;
    },
    cardBackgroundColor() {
      if (!this.isEditMode && this.companyColors.color2) {
        return this.companyColors.color2;
      }
      return null;
    },
    hasCardColor() {
      return !this.isEditMode && !!this.companyColors.color2;
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <div
    :class="b({ mobile: isMobile })"
    :style="isMobile && cardsBackgroundColor ? { backgroundColor: cardsBackgroundColor } : {}"
  >
    <!-- Desktop Layout -->
    <template v-if="!isMobile">
      <div
        :class="b('cards')"
        :style="cardsBackgroundColor ? { backgroundColor: cardsBackgroundColor } : {}"
      >
        <!-- Upload Card -->
        <div :class="b('card', { upload: true })">
          <div :class="b('card-icon')">
            <svg
              width="38"
              height="38"
              viewBox="0 0 38 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 2V26M19 2L10 11M19 2L28 11"
                stroke="#5F8AA4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 26V32C2 34.2091 3.79086 36 6 36H32C34.2091 36 36 34.2091 36 32V26"
                stroke="#5F8AA4"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <div :class="b('card-text')">
            <span :class="b('card-title')">UPLOAD</span>
            <span :class="b('card-subtitle')">YOUR FIRST PHOTO</span>
          </div>
        </div>

        <!-- Photo Enhance Card -->
        <div
          :class="b('card', { colored: hasCardColor })"
          :style="cardBackgroundColor ? { backgroundColor: cardBackgroundColor } : {}"
        >
          <div :class="b('card-content')">
            <span :class="b('card-label')">CHOOSE</span>
            <span :class="b('card-name')">ENHANCEMENTS</span>
          </div>
          <div :class="b('card-edit-icon')">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 2L20 6L7 19H3V15L16 2Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>

        <!-- Your Finished Products Card (Active) -->
        <div
          :class="b('card', { active: true, colored: hasCardColor })"
          :style="cardBackgroundColor ? { backgroundColor: cardBackgroundColor } : {}"
        >
          <div :class="b('card-content')">
            <span :class="b('card-label')">TYPE</span>
            <span :class="b('card-name')">INSTRUCTIONS</span>
          </div>
          <div :class="b('card-edit-icon')">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 2L20 6L7 19H3V15L16 2Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>

        <!-- Your Notes to the Artists Card -->
        <div
          :class="b('card', { colored: hasCardColor })"
          :style="cardBackgroundColor ? { backgroundColor: cardBackgroundColor } : {}"
        >
          <div :class="b('card-content')">
            <span :class="b('card-label')">SELECT</span>
            <span :class="b('card-name')">END-PRODUCTS</span>
          </div>
          <div :class="b('card-edit-icon')">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 2L20 6L7 19H3V15L16 2Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- Bottom Buttons Desktop -->
      <div :class="b('bottom-buttons')">
        <div :class="b('button-wrapper')">
          <button :class="b('upload-btn')">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2V16M12 2L7 7M12 2L17 7"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 16V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V16"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            UPLOAD MULTIPLE PHOTOS
          </button>
          <div :class="b('price-text')">
            <span :class="b('price-value')">$55</span>
            <span :class="b('price-discount')">$35</span>
            <span :class="b('price-label')">PER PHOTO.</span>
          </div>
        </div>

        <div :class="b('button-wrapper')">
          <button :class="b('scan-btn')">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="2"
                stroke="#5F8AA4"
                stroke-width="2"
              />
              <path
                d="M7 12H17M12 7V17"
                stroke="#5F8AA4"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            SWITCH TO PRO SCAN KIT
          </button>
          <div :class="b('price-text')">
            <span :class="b('price-value')">$55</span>
            <span :class="b('price-discount')">$35</span>
            <span :class="b('price-label')">PER PHOTO +</span>
            <span :class="b('price-discount')">$X</span>
            <span :class="b('price-label')">FOR PRO SCAN KIT</span>
          </div>
        </div>
      </div>
    </template>

    <!-- Mobile Layout -->
    <template v-else>
      <!-- Upload Area -->
      <div :class="b('mobile-upload-area')">
        <div :class="b('mobile-upload-icon')">
          <svg
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 2V26M19 2L10 11M19 2L28 11"
              stroke="#5F8AA4"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 26V32C2 34.2091 3.79086 36 6 36H32C34.2091 36 36 34.2091 36 32V26"
              stroke="#5F8AA4"
              stroke-width="3"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <span :class="b('mobile-upload-title')">UPLOAD</span>
        <span :class="b('mobile-upload-subtitle')">YOUR FIRST PHOTO</span>
      </div>

      <!-- Action Buttons -->
      <div :class="b('mobile-actions')">
        <button
          :class="b('mobile-action-btn', { colored: hasCardColor })"
          :style="cardBackgroundColor ? { backgroundColor: cardBackgroundColor } : {}"
        >
          <div :class="b('mobile-action-text')">
            <span :class="b('mobile-action-label')">NOTES TO</span>
            <span :class="b('mobile-action-value')">THE ARTISTS</span>
          </div>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 7L10 12L15 7"
              stroke="#7F7F7F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <button
          :class="b('mobile-action-btn', { colored: hasCardColor })"
          :style="cardBackgroundColor ? { backgroundColor: cardBackgroundColor } : {}"
        >
          <div :class="b('mobile-action-text')">
            <span :class="b('mobile-action-label')">YOUR PHOTO</span>
            <span :class="b('mobile-action-value')">ART TEAM</span>
          </div>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 7L10 12L15 7"
              stroke="#7F7F7F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <button
          :class="b('mobile-action-btn', { colored: hasCardColor })"
          :style="cardBackgroundColor ? { backgroundColor: cardBackgroundColor } : {}"
        >
          <div :class="b('mobile-action-text')">
            <span :class="b('mobile-action-label')">YOUR FINISHED</span>
            <span :class="b('mobile-action-value')">PRODUCTS</span>
          </div>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 7L10 12L15 7"
              stroke="#7F7F7F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <!-- Bottom Buttons Mobile -->
      <div :class="b('mobile-bottom-buttons')">
        <button :class="b('mobile-upload-btn')">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2V16M12 2L7 7M12 2L17 7"
              stroke="#5F8AA4"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 16V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V16"
              stroke="#5F8AA4"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          MULTIPLE PHOTOS
        </button>

        <button :class="b('mobile-scan-btn')">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="3"
              y="3"
              width="18"
              height="18"
              rx="2"
              stroke="#5F8AA4"
              stroke-width="2"
            />
            <path
              d="M7 12H17M12 7V17"
              stroke="#5F8AA4"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          SWITCH TO SCAN KIT
        </button>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables';
@import '@/styles/media';

.enhance-wizard-module {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 40px;
  border-radius: 20px;

  @include mediaMinMax(1025, $normal) {
    padding: vw-full(40);
    border-radius: vw-full(20);
  }

  &_mobile {
    padding: 20px;
    border-radius: 16px;
    background: #FFF;
  }

  // Desktop styles
  &__cards {
    display: flex;
    align-items: stretch;
    justify-content: center;
    gap: 16px;
    width: 100%;
    margin-bottom: 40px;
    width: 1544px;
    padding: 20px;
    border-radius: 40px;
    border: 1px solid var(--Light-Blue, #D7E8F0);
    background: #FFF;
    box-shadow: 4px 4px 8px 0 rgba(95, 138, 164, 0.20);

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(16);
      margin-bottom: vw-full(40);
      width: vw-full(1544);
      padding: vw-full(20);
      border-radius: vw-full(40);
    }
  }

  &__card {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    width: 372px;
    height: 300px;
    border-radius: 20px;
    background: #F1F0F1;
    padding: 20px;
    position: relative;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(372);
      height: vw-full(300);
      border-radius: vw-full(20);
      padding: vw-full(20);
    }

    &_upload {
      align-items: center;
      justify-content: center;
      gap: 12px;
      background: var(--special-light-blue, #EAF8FF);
    }

    &_colored {
      .enhance-wizard-module__card-title,
      .enhance-wizard-module__card-subtitle,
      .enhance-wizard-module__card-label,
      .enhance-wizard-module__card-name {
        color: #fff;
      }

      .enhance-wizard-module__card-icon svg path {
        stroke: #fff;
      }
    }
  }

  &__card-icon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(38);
      height: vw-full(38);
    }
  }

  &__card-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  &__card-title {
    color: #5F8AA4;
    font-size: 24px;
    font-weight: 600;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(24);
    }
  }

  &__card-subtitle {
    color: #5F8AA4;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(14);
    }
  }

  &__card-content {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
  }

  &__card-label {
    color: #7F7F7F;
    font-size: 18px;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 1.2;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(18);
    }
  }

  &__card-name {
    color: #7F7F7F;
    font-size: 32px;
    font-weight: 600;
    text-transform: uppercase;
    line-height: 1.1;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(32);
    }
  }

  &__card-edit-icon {
    position: absolute;
    bottom: 20px;
    right: 20px;
    width: 22px;
    height: 22px;
    opacity: 0.6;

    @include mediaMinMax(1025, $normal) {
      bottom: vw-full(20);
      right: vw-full(20);
      width: vw-full(22);
      height: vw-full(22);
    }
  }

  &__bottom-buttons {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 24px;
    width: 100%;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(24);
    }
  }

  &__button-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(12);
    }
  }

  &__upload-btn,
  &__scan-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 560px;
    height: 100px;
    border-radius: 40px;
    font-family: Montserrat, sans-serif;
    font-size: 28px;
    font-weight: 500;
    text-transform: uppercase;
    color: #5F8AA4;
    cursor: pointer;
    border: none;
    transition: all 0.2s ease;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(560);
      height: vw-full(100);
      gap: vw-full(12);
      font-size: vw-full(28);
      border-radius: vw-full(40);
    }

    svg {
      width: 20px;
      height: 20px;
      flex-shrink: 0;

      @include mediaMinMax(1025, $normal) {
        width: vw-full(20);
        height: vw-full(20);
      }
    }
  }

  &__upload-btn {
    background: #F7F8F9;
    box-shadow: 4px 4px 8px 0 rgba(95, 138, 164, 0.20);
  }

  &__scan-btn {
    background: #FFF;
    border: 1px solid #F7F8F9;
    box-shadow: 4px 4px 8px 0 rgba(95, 138, 164, 0.20);
  }

  &__price-text {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: Montserrat, sans-serif;
    font-size: 20px;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(20);
      gap: vw-full(4);
    }
  }

  &__price-value {
    color: #7F7F7F;
    text-decoration: line-through;
    font-weight: 400;
  }

  &__price-discount {
    color: #ECC486;
    font-weight: 500;
  }

  &__price-label {
    color: #5F8AA4;
    font-weight: 400;
  }

  // Mobile styles
  &__mobile-upload-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 412px;
    height: 232px;
    background: #EAF8FF;
    margin-bottom: 20px;
  }

  &__mobile-upload-icon {
    width: 38px;
    height: 38px;
    margin-bottom: 16px;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__mobile-upload-title {
    color: #5F8AA4;
    font-family: Montserrat, sans-serif;
    font-size: 48px;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 1;
  }

  &__mobile-upload-subtitle {
    color: #5F8AA4;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-weight: 400;
    text-transform: uppercase;
    margin-top: 8px;
  }

  &__mobile-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
    margin-bottom: 20px;
  }

  &__mobile-action-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 356px;
    height: 64px;
    padding: 0 24px;
    border-radius: 40px;
    border: 1px solid #D9D9D9;
    background: #FFF;
    cursor: pointer;

    svg {
      flex-shrink: 0;
    }

    &_colored {
      border-color: transparent;

      .enhance-wizard-module__mobile-action-label,
      .enhance-wizard-module__mobile-action-value {
        color: #fff;
      }

      svg path {
        stroke: #fff;
      }
    }
  }

  &__mobile-action-text {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__mobile-action-label {
    color: #7F7F7F;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-weight: 400;
    text-transform: uppercase;
  }

  &__mobile-action-value {
    color: #7F7F7F;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
  }

  &__mobile-bottom-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
  }

  &__mobile-upload-btn,
  &__mobile-scan-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 300px;
    height: 60px;
    border-radius: 40px;
    background: #EAF8FF;
    box-shadow: 3px 3px 6px 0 rgba(95, 138, 164, 0.20);
    border: none;
    cursor: pointer;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    color: #5F8AA4;

    svg {
      flex-shrink: 0;
    }
  }
}
</style>
